import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';

@Component({
    selector: 'currency-balances-cellrender',
    templateUrl: './currency-balances-cellrender.component.html'
})
export class CurrencyBalancesCellrenderComponent implements ICellRendererAngularComp {

    data: any;
    isParentRowCell: boolean = false;
    colName: string = '';
    isGroup: boolean;
    countryCurrency: string = '';

    // called on init
    agInit(params: any): void {
        this.data = params.data == undefined ? params.node.allLeafChildren[0].data: params.data;
        this.countryCurrency = this.data.localCcy.substring(0,2);
        this.isGroup = this.data.localCcy.indexOf('Net ') !== -1 && !params.node.group;
        if (this.data.parent.length == 1){
            this.isParentRowCell = true
        }
        this.colName = params && params.colDef ? params.colDef.headerName : '';
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        return true;
    }
}
